<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-glass-mug">{{
              $t("dashboardCardSuperAdminPhotoGift")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeGift.gift"
                :search="search"
                sort-by="giftCategory"
                :items-per-page="-1"
                group-by="giftCategory"
                must-sort
                show-expand
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length" class="py-2">
                    <!-- ID -->
                    <div class="py-1">
                      <span class="overline"
                        >{{ $t("settingsPhotoGiftIdTitle") }}:</span
                      >
                      {{ item.id }}
                    </div>

                    <!-- RAZLIČICE NASLOV / GUMB / DIALOG ADD / EDIT-->
                    <div class="py-1 overline d-flex">
                      <div class="pt-1">
                        {{ $t("settingsPhotoGiftTypeTitle") }}
                      </div>
                      <v-btn
                        v-if="!item.typeArray || item.typeArray.length == 0"
                        color="primary"
                        style="min-width: 0; width: 20px"
                        text
                        @click="editItem(item)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <!-- ADD / EDIT ITEM TYPE -->
                      <v-dialog
                        v-model="dialogType"
                        max-width="500px"
                        persistent
                        transition="dialog-bottom-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            v-on="on"
                            style="min-width: 0; width: 20px"
                            text
                            @click="currentTypeId = item.id"
                          >
                            <v-icon>mdi-plus-circle</v-icon>
                          </v-btn>
                        </template>
                        <v-form ref="formType">
                          <v-card
                            :class="
                              getTheme() == 'dark'
                                ? 'outlined elevation-0'
                                : 'flat elevation-0'
                            "
                            :style="
                              getTheme() == 'dark'
                                ? ''
                                : 'border-bottom: 1px solid lightgray'
                            "
                          >
                            <v-card-title
                              :style="
                                getTheme() == 'dark'
                                  ? 'background-color: #505050'
                                  : 'background-color: white; border-bottom: 1px solid lightgray'
                              "
                              :class="
                                getTheme() == 'dark'
                                  ? 'white--text'
                                  : '#505050--text'
                              "
                              class="title font-weight-regular"
                            >
                              <v-icon
                                :class="
                                  getTheme() == 'dark'
                                    ? 'white--text'
                                    : 'primary--text'
                                "
                                class="mr-3"
                                medium
                                >{{
                                  editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                                }}</v-icon
                              >
                              {{ formTitle }}
                            </v-card-title>
                            <v-card-text class="py-0 pt-2">
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemType.order"
                                      type="number"
                                      :label="$t('settingsPhotoGiftOrderTitle')"
                                      :rules="[
                                        validateRequired(),
                                        validateIsNumber(),
                                      ]"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-file-input
                                      :clearable="true"
                                      accept="image/jpeg, image/png"
                                      prepend-icon="mdi-camera"
                                      v-model="editedItemType.image"
                                      class="mt-0 pa-0"
                                      :label="
                                        $t('settingsPhotoGiftImageTypeTitle')
                                      "
                                    ></v-file-input>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemType.title"
                                      :label="$t('settingsPhotoGiftNameTitle')"
                                      :rules="[
                                        validateRequired(),
                                        validateMaxLength(150),
                                      ]"
                                      :counter="150"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-textarea
                                      v-model="editedItemType.description"
                                      :label="
                                        $t('settingsPhotoGiftDescriptionTitle')
                                      "
                                      :rules="[validateMaxLength(500)]"
                                      :counter="500"
                                      dense
                                    ></v-textarea>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemType.price"
                                      :label="$t('settingsPhotoGiftPriceTitle')"
                                      :rules="[
                                        validateRequired(),
                                        validateIsCurrency(),
                                        validateMaxLength(20),
                                      ]"
                                      :counter="20"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemType.inventory"
                                      type="number"
                                      :label="
                                        $t('settingsPhotoGiftInventoryTitle')
                                      "
                                      :rules="[
                                        validateRequired(),
                                        validateIsNumber(),
                                      ]"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions
                              :class="
                                getTheme() == 'dark'
                                  ? '#505050--text'
                                  : '#505050--text'
                              "
                              :style="
                                getTheme() == 'dark'
                                  ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                                  : 'background-color: white; border-top: 1px solid lightgray;'
                              "
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                class="my-1"
                                text
                                @click="closeType()"
                                >{{ $t("addEditFormCancelButton") }}</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn @click="saveType" color="primary" dark>
                                <v-icon medium class="mr-1"
                                  >mdi-content-save</v-icon
                                >
                                {{ $t("addEditFormSaveButton") }}
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-dialog>
                    </div>

                    <!-- RAZLIČICE LIST ITEMS-->
                    <div
                      v-if="item.typeArray && item.typeArray.length > 0"
                      class="py-1"
                    >
                      <div
                        v-for="(item2, index) in item.typeArray"
                        :key="index"
                        class="d-flex align-center"
                      >
                        <v-btn
                          color="primary"
                          @click="editType({ item: item, type: item2 })"
                          style="min-width: 0; width: 20px"
                          text
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="
                            deleteItemTypeSet({
                              id: item2.id,
                              imageURL: item2.imageURL,
                              item: item,
                            })
                          "
                          style="min-width: 0; width: 20px"
                          text
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <div class="py-1 px-1" v-if="item2.image.length > 0">
                          <v-img
                            :src="item2.image"
                            style="max-width: 35px"
                          ></v-img>
                        </div>
                        <div class="py-1 px-1" v-else>
                          <v-img
                            :src="defaultImage"
                            style="max-width: 35px"
                          ></v-img>
                        </div>
                        <div class="py-1 px-1">{{ item2.order }}</div>
                        <div class="py-1 px-1">{{ item2.title }}</div>
                        <div class="py-1 px-1">
                          {{ item2.price }}
                          {{
                            $store.state.storeClient.client.environmentSettings
                              .currency
                          }}
                        </div>
                        <div class="py-1 px-1">
                          {{ item2.inventory }} {{ $t("lmPcs") }}
                        </div>
                        <div class="py-1 px-1">
                          {{ item2.id }}
                        </div>
                      </div>
                    </div>
                    <div v-else class="py-1">{{ item.type }}</div>

                    <div class="py-1 overline d-flex">
                      <div class="pt-1">
                        {{ $t("settingsPhotoGiftPrintSizeTitle") }}
                      </div>
                      <!-- ADD / EDIT POVEZANE PREDLOGE TYPE -->
                      <v-dialog
                        v-model="dialogPrintSize"
                        max-width="500px"
                        persistent
                        transition="dialog-bottom-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="primary"
                            v-on="on"
                            style="min-width: 0; width: 20px"
                            text
                            @click="currentPrintSizeId = item.id"
                          >
                            <v-icon>mdi-plus-circle</v-icon>
                          </v-btn>
                        </template>
                        <v-form ref="formPrintSize">
                          <v-card
                            :class="
                              getTheme() == 'dark'
                                ? 'outlined elevation-0'
                                : 'flat elevation-0'
                            "
                            :style="
                              getTheme() == 'dark'
                                ? ''
                                : 'border-bottom: 1px solid lightgray'
                            "
                          >
                            <v-card-title
                              :style="
                                getTheme() == 'dark'
                                  ? 'background-color: #505050'
                                  : 'background-color: white; border-bottom: 1px solid lightgray'
                              "
                              :class="
                                getTheme() == 'dark'
                                  ? 'white--text'
                                  : '#505050--text'
                              "
                              class="title font-weight-regular"
                            >
                              <v-icon
                                :class="
                                  getTheme() == 'dark'
                                    ? 'white--text'
                                    : 'primary--text'
                                "
                                class="mr-3"
                                medium
                                >{{
                                  editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                                }}</v-icon
                              >
                              {{ formTitle }}
                            </v-card-title>
                            <v-card-text class="py-0 pt-2">
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemPrintSize.order"
                                      type="number"
                                      :label="$t('settingsPhotoGiftOrderTitle')"
                                      :rules="[
                                        validateRequired(),
                                        validateIsNumber(),
                                      ]"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemPrintSize.codes"
                                      :label="$t('settingsPhotoGiftCodesTitle')"
                                      :rules="[
                                        validateRequired(),
                                        validateMaxLength(350),
                                      ]"
                                      :counter="150"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-file-input
                                      :clearable="true"
                                      accept="image/jpeg, image/png"
                                      prepend-icon="mdi-camera"
                                      v-model="editedItemPrintSize.image"
                                      class="mt-0 pa-0"
                                      :label="
                                        $t('settingsPhotoGiftImageSizeTitle')
                                      "
                                    ></v-file-input>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      dense
                                      v-model="editedItemPrintSize.title"
                                      :label="$t('settingsPhotoGiftNameTitle')"
                                      :rules="[validateMaxLength(250)]"
                                      :counter="150"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions
                              :class="
                                getTheme() == 'dark'
                                  ? '#505050--text'
                                  : '#505050--text'
                              "
                              :style="
                                getTheme() == 'dark'
                                  ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                                  : 'background-color: white; border-top: 1px solid lightgray;'
                              "
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                class="my-1"
                                text
                                @click="closePrintSize()"
                                >{{ $t("addEditFormCancelButton") }}</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn
                                @click="savePrintSize"
                                color="primary"
                                dark
                              >
                                <v-icon medium class="mr-1"
                                  >mdi-content-save</v-icon
                                >
                                {{ $t("addEditFormSaveButton") }}
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-dialog>
                    </div>
                    <div
                      v-if="
                        item.printSizeArray && item.printSizeArray.length > 0
                      "
                      class="py-1"
                    >
                      <div
                        v-for="(item2, index) in item.printSizeArray"
                        :key="index"
                        class="d-flex align-center"
                      >
                        <v-btn
                          color="primary"
                          @click="editPrintSize({ item: item, type: item2 })"
                          style="min-width: 0; width: 20px"
                          text
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="
                            deleteItemPrintSizeSet({
                              id: item2.id,
                              imageURL: item2.imageURL,
                              item: item,
                            })
                          "
                          style="min-width: 0; width: 20px"
                          text
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <div
                          class="py-1 px-1 d-flex align-center"
                          v-if="item2.image.length > 0"
                        >
                          <v-img
                            :src="item2.image"
                            style="max-width: 35px"
                          ></v-img>
                          <v-btn
                            color="secondary"
                            style="min-width: 0; width: 20px"
                            text
                            @click="
                              deletePrintSizeImageSet({
                                item: item,
                                item2: item2,
                              })
                            "
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <div class="py-1 px-1" v-else>
                          <v-img
                            :src="defaultImage"
                            style="max-width: 35px"
                          ></v-img>
                        </div>
                        <div class="py-1 px-1">{{ item2.order }}</div>
                        <div class="py-1 px-1">{{ item2.title }}</div>
                        <div
                          v-for="(item3, index3) in item2.codesArray"
                          :key="index3"
                          class="d-flex align-center"
                        >
                          <v-chip color="accent" class="px-2 mx-1"
                            >{{ item3.code }}
                            <v-btn
                              v-if="item2.image.length > 0"
                              color="white"
                              class="pa-0 ma-0"
                              style="max-width: 24px"
                              fab
                              x-small
                              text
                              @click="editCoordinates(item, item2, item3.code)"
                            >
                              <v-icon>mdi-border-outside</v-icon>
                            </v-btn>
                          </v-chip>
                        </div>
                      </div>
                    </div>
                    <div
                      v-show="item.description.length != ''"
                      class="py-1 overline"
                    >
                      {{ $t("settingsPhotoGiftDescriptionTitle") }}
                    </div>
                    <div v-show="item.description.length != ''" class="py-1">
                      {{ item.description }}
                    </div>
                    <div
                      v-show="item.sendExtraEmailOnOrder.length != ''"
                      class="py-1 overline"
                    >
                      {{ $t("settingsPhotoGiftSendExtraEmailOnOrderTitle") }}
                    </div>
                    <div
                      v-show="item.sendExtraEmailOnOrder.length != ''"
                      class="py-1"
                    >
                      {{ item.sendExtraEmailOnOrder }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.active="{ item }">
                  <v-icon
                    @click="
                      toggleGiftBooleanActive(item, 'toggleGiftBooleanActive')
                    "
                    :color="item.active ? 'success' : 'error'"
                    >{{
                      item.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.allowTemplateClones="{ item }">
                  <v-icon
                    @click="
                      toggleGiftBooleanActive(
                        item,
                        'toggleGiftBooleanAllowTemplateClones'
                      )
                    "
                    :color="item.allowTemplateClones ? 'success' : 'error'"
                    >{{
                      item.allowTemplateClones
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.allowCustomSize="{ item }">
                  <v-icon
                    @click="
                      toggleGiftBooleanActive(
                        item,
                        'toggleGiftBooleanAllowCustomSize'
                      )
                    "
                    :color="item.allowCustomSize ? 'success' : 'error'"
                    >{{
                      item.allowCustomSize
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.overrideSize="{ item }">
                  <v-icon
                    @click="
                      toggleGiftBooleanActive(
                        item,
                        'toggleGiftBooleanOverrideSize'
                      )
                    "
                    :color="item.overrideSize ? 'success' : 'error'"
                    >{{
                      item.overrideSize
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.enableSmallDevices="{ item }">
                  <v-icon
                    @click="
                      toggleGiftBooleanActive(
                        item,
                        'toggleGiftBooleanEnableSmallDevices'
                      )
                    "
                    :color="item.enableSmallDevices ? 'success' : 'error'"
                    >{{
                      item.enableSmallDevices
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.enableDeviceBasedEdit="{ item }">
                  <v-icon
                    @click="
                      toggleGiftBooleanActive(
                        item,
                        'toggleGiftBooleanEnableDeviceBasedEdit'
                      )
                    "
                    :color="item.enableDeviceBasedEdit ? 'success' : 'error'"
                    >{{
                      item.enableDeviceBasedEdit
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.image="{ item }">
                  <v-flex row>
                    <v-img
                      :src="item.image.length > 0 ? item.image : defaultImage"
                      :style="
                        item.image.length > 0
                          ? 'max-width: 100px'
                          : 'max-width: 50px'
                      "
                    ></v-img>
                    <v-icon
                      v-if="item.imageURL.length > 0"
                      class="ml-2"
                      @click="deleteImageItem(item)"
                      >mdi-delete</v-icon
                    >
                  </v-flex>
                </template>
                <template v-slot:item.superType="{ item }">
                  <span v-if="item.superType == 0">
                    {{ $t("settingsPhotoGiftSuperTypeItemTitle") }}
                  </span>
                  <span v-else-if="item.superType == 1">
                    {{ $t("settingsPhotoGiftSuperTypeGiftTitle") }}
                  </span>
                  <span v-else-if="item.superType == 2">
                    {{ $t("settingsPhotoGiftSuperTypeCollageTitle") }}
                  </span>
                  <span v-else-if="item.superType == 3">
                    {{ $t("settingsPhotoGiftSuperTypeCustomTitle") }}
                  </span>
                  <span v-else-if="item.superType == 4">
                    {{ $t("settingsPhotoGiftSuperTypeGiftCardTitle") }}
                  </span>
                  <span v-else-if="item.superType == 5">
                    {{ $t("settingsPhotoGiftSuperTypeLargePrintTitle") }}
                  </span>
                  <span v-else-if="item.superType == 6">
                    {{ $t("settingsPhotoGiftSuperTypePhotoCanvasTitle") }}
                  </span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon class="mr-3" @click="openTemplates(item)"
                      >mdi-image-album</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-flex>

          <!-- DELETE CONFIRM DIALOG -->
          <dialog-basic-yes-no
            :active="dialogDelete"
            @clickYes="deleteItem"
            @clickNo="dialogDelete = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgQuestion')"
            >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
          >

          <!-- DELETE SIMPLE CONFIRM DIALOG -->
          <dialog-basic-yes-no
            :active="dialogSimpleDelete"
            @clickYes="deleteSimpleItemImage"
            @clickNo="dialogSimpleDelete = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgQuestion')"
            >{{ $t("askSimpleImageDelete") }}</dialog-basic-yes-no
          >

          <!-- DELETE CONFIRM ITEM TYPES DIALOG -->
          <dialog-basic-yes-no
            :active="dialogDeleteType"
            @clickYes="deleteItemType"
            @clickNo="dialogDeleteType = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgQuestion')"
            >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
          >

          <!-- DELETE CONFIRM LINKED TEMPLATES DIALOG -->
          <dialog-basic-yes-no
            :active="dialogDeletePrintSize"
            @clickYes="deleteItemPrintSize"
            @clickNo="dialogDeletePrintSize = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgQuestion')"
            >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
          >

          <!-- DELETE CONFIRM LINKED TEMPLATES IMAGE DIALOG -->
          <dialog-basic-yes-no
            :active="dialogDeletePrintSizeImage"
            @clickYes="deletePrintSizeImage"
            @clickNo="dialogDeletePrintSizeImage = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgQuestion')"
            >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
          >

          <!-- PLEASE WAIT DIALOG -->
          <v-dialog
            v-model="dialogWait"
            persistent
            max-width="400"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-card-title class="headline">{{
                $t("userNewOrderPleaseWaitTitle")
              }}</v-card-title>
              <v-card-text class="d-flex">
                <v-spacer></v-spacer>
                <v-progress-linear
                  color="primary"
                  height="10"
                  indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-dialog>

          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuModulePhotoGift' })"
          ></simple-navigation-button>

          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="950px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                @click="editItem('add')"
                v-on="on"
                dark
                fixed
                bottom
                right
                rounded
              >
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >{{
                      this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                    }}</v-icon
                  >
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 md6>
                        <v-flex xs12>
                          <v-select
                            v-model="editedItem.superType"
                            :items="giftSuperType"
                            item-text="name"
                            item-value="type"
                            :label="$t('settingsPhotoGiftSuperTypeTitle')"
                            :rules="[validateRequired()]"
                            dense
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            dense
                            v-model="editedItem.order"
                            type="number"
                            :label="$t('settingsPhotoGiftOrderTitle')"
                            :rules="[validateRequired(), validateIsNumber()]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            dense
                            v-model="editedItem.name"
                            :label="$t('settingsPhotoGiftNameTitle')"
                            :rules="[validateRequired(), validateMaxLength(50)]"
                            :counter="50"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            v-model="editedItem.giftCategory"
                            :items="$store.state.storeGiftCategory.giftCategory"
                            item-text="name"
                            item-value="name"
                            :label="$t('settingsPhotoGiftCategoryTitle')"
                            :rules="[validateRequired()]"
                            dense
                          ></v-select>
                        </v-flex>
                        <!--<v-flex xs12>
                        <v-textarea
                          dense
                          v-model="editedItem.printSize"
                          :label="$t('settingsPhotoGiftPrintSizeTitle')"
                          :rules="[validateMaxLength(1000)]"
                          :counter="1000"
                        ></v-textarea>
                      </v-flex>-->
                        <v-flex xs12>
                          <v-text-field
                            dense
                            v-model="editedItem.type"
                            :label="$t('settingsPhotoGiftTypeTitle')"
                            :rules="[validateMaxLength(500)]"
                            :counter="500"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            dense
                            v-model="editedItem.price"
                            :label="$t('settingsPhotoGiftPriceTitle')"
                            :rules="[
                              validateRequired(),
                              validateIsCurrency(),
                              validateMaxLength(20),
                            ]"
                            :counter="20"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="editedItem.description"
                            :label="$t('settingsPhotoGiftDescriptionTitle')"
                            :rules="[validateMaxLength(350)]"
                            :counter="350"
                            dense
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                          <v-file-input
                            :clearable="true"
                            accept="image/jpeg, image/png"
                            prepend-icon="mdi-camera"
                            v-model="editedItem.image"
                            class="mt-0 pa-0"
                            :label="$t('settingsPhotoGiftImageTitle')"
                          ></v-file-input>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            dense
                            v-model="editedItem.sendExtraEmailOnOrder"
                            :label="
                              $t('settingsPhotoGiftSendExtraEmailOnOrderTitle')
                            "
                            :rules="[validateMaxLength(500)]"
                            :counter="500"
                          ></v-text-field>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-flex
                          xs12
                          v-if="
                            editedItem.superType == 100 ||
                            editedItem.superType == 4
                          "
                        >
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.skipEdit"
                            :label="$t('settingsPhotoGiftSkipEditTitle')"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType == 4">
                          <v-select
                            v-model="editedItem.validTo"
                            :items="giftCardTemplateValidItems"
                            item-text="title"
                            item-value="days"
                            :label="$t('settingsPhotoGiftValidToTitle')"
                            :rules="[validateRequired()]"
                            dense
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            dense
                            v-model="editedItem.minOrder"
                            type="number"
                            :label="$t('settingsPhotoGiftMinOrderTitle')"
                            :rules="[validateRequired(), validateIsNumber()]"
                          ></v-text-field>
                        </v-flex>
                        <!--<v-flex xs12 v-show="editedItem.allowTemplateClones">
                          <v-text-field
                            dense
                            v-model="editedItem.minTemplateClones"
                            type="number"
                            :label="
                              $t('settingsPhotoGiftMinTemplateClonesTitle')
                            "
                            :rules="[validateRequired(), validateIsNumber()]"
                          ></v-text-field>
                        </v-flex>-->
                        <v-flex xs12 v-if="editedItem.superType != 100">
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.allowTemplateClones"
                            :label="
                              $t('settingsPhotoGiftAllowTemplateClonesTitle')
                            "
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType != 100">
                          <v-text-field
                            dense
                            v-model="editedItem.maxTemplateClones"
                            type="number"
                            :label="
                              $t('settingsPhotoGiftMaxTemplateClonesTitle')
                            "
                            :rules="[validateRequired(), validateIsNumber()]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType == 3">
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.allowCustomSize"
                            @change="
                              editedItem.allowTemplateClones =
                                editedItem.allowCustomSize
                            "
                            :label="$t('settingsPhotoGiftAllowCustomSizeTitle')"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType == 2">
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.overrideSize"
                            @change="editedItem.allowCustomSize = false"
                            :label="$t('settingsPhotoGiftOverrideSizeTitle')"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType == 2">
                          <v-text-field
                            dense
                            v-model="editedItem.overrideSizeWidth"
                            type="number"
                            :label="
                              $t('settingsPhotoGiftOverrideSizeWidthTitle')
                            "
                            :rules="[validateRequired(), validateIsNumber()]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType == 2">
                          <v-text-field
                            dense
                            v-model="editedItem.overrideSizeHeight"
                            type="number"
                            :label="
                              $t('settingsPhotoGiftOverrideSizeHeightTitle')
                            "
                            :rules="[validateRequired(), validateIsNumber()]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType != 100">
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.enableSmallDevices"
                            :label="
                              $t('settingsPhotoGiftEnableSmallDevicesTitle')
                            "
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.superType != 100">
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.enableDeviceBasedEdit"
                            :label="
                              $t('settingsPhotoGiftEnableDeviceBasedEdit')
                            "
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12>
                          <v-switch
                            dense
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="editedItem.active"
                            :label="$t('settingsPhotoGiftActiveTitle')"
                          ></v-switch>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="my-1" text @click="close()">{{
                    $t("addEditFormCancelButton")
                  }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>

          <!-- EDIT PREVIEW IMAGE COORDINATES DIALOG -->
          <v-dialog
            v-model="dialogEditImageCoordinates"
            persistent
            style="z-index: 2000"
            :fullscreen="true"
            :scrollable="true"
            transition="dialog-bottom-transition"
          >
            <v-card
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-border-outside</v-icon
                >
                {{ $t("settingsPhotoGiftPreviewImageCoodrinatesTitle") }}
                <v-spacer></v-spacer>
                <v-btn
                  text
                  medium
                  @click="dialogEditImageCoordinates = false"
                  style="min-width: 0; width: 20px"
                >
                  <v-icon
                    medium
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    >mdi-close-box</v-icon
                  >
                </v-btn>
              </v-card-title>
              <v-card-text class="d-flex ma-0 pa-2">
                <div
                  id="canvasEditImageCoordinates"
                  class="d-flex"
                  style="width: 100%"
                >
                  <v-spacer></v-spacer>
                  <canvas
                    ref="fabricEditImageCoordinates"
                    style="object-fit: contain; border: 1px solid forestgreen"
                  ></canvas>
                  <v-spacer></v-spacer>
                </div>
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="my-1 mr-5"
                  text
                  @click="dialogEditImageCoordinates = false"
                  >{{ $t("addEditFormCancelButton") }}</v-btn
                >
                <v-btn
                  @click="saveEditImageCoordinates()"
                  color="primary"
                  dark
                  class="ml-5"
                >
                  <v-icon medium class="mr-1">mdi-content-save</v-icon>
                  {{ $t("addEditFormSaveButton") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import "firebase/functions";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";
import { readImageDimensions } from "@/mixins/modPhotoOrderUploadService";
import { fabric } from "fabric";
import "fabric-customise-controls";
import { G_MODULE_PHOTO_GIFT } from "@/constants";

export default {
  name: "settingsPhotoGift",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      defaultImage: require("@/assets/giftCategoryDefault.jpg"),
      resizeIconTR: require("@/assets/resize-icon-tr.svg"),
      resizeIconTL: require("@/assets/resize-icon-tl.svg"),
      resizeIconBR: require("@/assets/resize-icon-br.svg"),
      resizeIconBL: require("@/assets/resize-icon-bl.svg"),
      rotateIconSVG: require("@/assets/rotate-icon.svg"),
      search: "",
      dialogSimpleDelete: false,
      dialog: false,
      dialogType: false,
      dialogPrintSize: false,
      dialogDelete: false,
      dialogDeleteType: false,
      dialogDeletePrintSize: false,
      dialogDeletePrintSizeImage: false,
      dialogEditImageCoordinates: false,
      dialogDeleteId: "",
      dialogWait: false,
      canvasPreviewTemplate: null,
      headers: [
        {
          text: this.$t("settingsPhotoGiftOrderTitle"),
          align: "center",
          value: "order",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftSuperTypeTitle"),
          align: "center",
          value: "superType",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftCategoryTitle"),
          align: "center",
          value: "giftCategory",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftNameTitle"),
          align: "center",
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftPriceTitle"),
          align: "center",
          value: "price",
          sortable: true,
        },
        /*{
          text: this.$t("settingsPhotoGiftPrintSizeTitle"),
          align: "center",
          value: "printSize",
          sortable: true
        },*/
        {
          align: "center",
          value: "image",
        },
        {
          text: this.$t("settingsPhotoGiftMinOrderTitle"),
          align: "center",
          value: "minOrder",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftAllowTemplateClonesTitle"),
          align: "center",
          value: "allowTemplateClones",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftAllowCustomSizeTitle"),
          align: "center",
          value: "allowCustomSize",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftOverrideSizeTitle"),
          align: "center",
          value: "overrideSize",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftEnableSmallDevicesShortTitle"),
          align: "center",
          value: "enableSmallDevices",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftEnableDeviceBasedEditShort"),
          align: "center",
          value: "enableDeviceBasedEdit",
          sortable: true,
        },
        {
          text: this.$t("settingsPhotoGiftActiveTitle"),
          align: "center",
          value: "active",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: this.$t("msgMore"),
          value: "data-table-expand",
        },
      ],
      editedIndex: -1,
      editedItem: {
        superType: 1,
        order: 1,
        name: "",
        description: "",
        keywords: "",
        image: [],
        imageURL: "",
        giftCategory: "",
        type: "",
        typeArray: [],
        //printSize: "",
        printSizeArray: [],
        price: 0,
        skipEdit: false,
        validTo: 365,
        minOrder: 1,
        minTemplateClones: 0,
        maxTemplateClones: 0,
        allowTemplateClones: false,
        allowCustomSize: false,
        overrideSize: false,
        overrideSizeWidth: 0,
        overrideSizeHeight: 0,
        enableSmallDevices: true,
        enableDeviceBasedEdit: false,
        sendExtraEmailOnOrder: "",
        active: true,
        client: this.$store.state.storeClient.client.basicSettings.name,
      },
      defaultItem: {
        superType: 1,
        order: 1,
        name: "",
        description: "",
        keywords: "",
        image: [],
        imageURL: "",
        giftCategory: "",
        type: "",
        typeArray: [],
        //printSize: "",
        printSizeArray: [],
        price: 0,
        skipEdit: false,
        validTo: 365,
        minOrder: 1,
        minTemplateClones: 0,
        maxTemplateClones: 0,
        allowTemplateClones: false,
        allowCustomSize: false,
        overrideSize: false,
        overrideSizeWidth: 0,
        overrideSizeHeight: 0,
        enableSmallDevices: true,
        enableDeviceBasedEdit: false,
        sendExtraEmailOnOrder: "",
        active: true,
        client: this.$store.state.storeClient.client.basicSettings.name,
      },
      currentTypeId: "", // id izdelka, da vemo kam pripeti ItemType
      editedItemType: {
        image: [],
        imageURL: "",
        inventory: -1,
        order: 1,
        price: 0,
        title: "",
        description: "",
      },
      defaultItemType: {
        image: [],
        imageURL: "",
        inventory: -1,
        order: 1,
        price: 0,
        title: "",
        description: "",
      },
      currentPrintSizeId: "", // id izdelka, da vemo kam pripeti ItemType
      editedItemPrintSize: {
        image: [],
        imageURL: "",
        imageWidth: 0,
        imageHeight: 0,
        imageAspectRatio: 0,
        order: 1,
        title: "",
        codes: "",
      },
      defaultItemPrintSize: {
        image: [],
        imageURL: "",
        imageWidth: 0,
        imageHeight: 0,
        imageAspectRatio: 0,
        order: 1,
        title: "",
        codes: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    async toggleGiftBooleanActive(item, field) {
      try {
        await this.$store.dispatch(field, item);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    deleteImageItem(item) {
      this.dialogSimpleDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteSimpleItemImage() {
      try {
        this.dialogWait = true;
        await firebase
          .functions()
          .httpsCallable("deleteImageFromStorage")([
            this.dialogDeleteId.imageURL,
          ])
          .then(async (res) => {
            await this.$store.dispatch(
              "removeImageLinkFromGift",
              this.dialogDeleteId
            );
            this.dialogWait = false;

            if (res.data[0] == "OK") {
              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("msgSuccessImageDelete"),
              });
            } else
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: this.$t("msgErrorImageDelete"),
              });
          })
          .catch((error) => {
            this.dialogWait = false;
            console.log(error);
          });
        this.dialogWait = false;

        this.dialogSimpleDelete = false;
      } catch (error) {
        this.dialogWait = false;
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    async saveEditImageCoordinates() {
      this.dialogEditImageCoordinates = false;
      this.dialogWait = true;

      let coords = {};

      this.canvasPreviewTemplate.canvas.getObjects().filter((o) => {
        if (o.get("type") === "rect") {
          coords = {
            left: Math.round(o.left),
            top: Math.round(o.top),
            width: Math.round(o.getScaledWidth()),
            height: Math.round(o.getScaledHeight()),
            angle: Math.round(o.angle),
          };
        }
      });

      let foundIndex =
        this.$store.state.storeGift.getTemplateDimensions.printSizeArray.findIndex(
          (x) => x.id == this.$store.state.storeGift.getTemplateDimensions.aId
        );
      let foundItem =
        this.$store.state.storeGift.getTemplateDimensions.printSizeArray[
          foundIndex
        ].codesArray.findIndex(
          (x) =>
            x.code == this.$store.state.storeGift.getTemplateDimensions.code
        );

      this.$store.state.storeGift.getTemplateDimensions.printSizeArray[
        foundIndex
      ].codesArray[foundItem].coordinates = coords;

      try {
        await this.$store.dispatch("saveTemplateDimensions");
        this.refresh();
        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessEdit"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
      }

      this.dialogWait = false;
    },
    async editCoordinates(item, item2, item3) {
      try {
        await this.$store.dispatch("getTemplateDimensions", {
          id: item.id,
          aId: item2.id,
          client: this.$store.state.storeClient.client.basicSettings.name,
          module: this.G_MODULE_PHOTO_GIFT,
          code: item3,
          printSizeArray: item.printSizeArray,
        });

        //console.log(id, item2, item3);
        this.dialogEditImageCoordinates = true;

        // poiščemo koordinate za izbrano kodo
        let cArray = item2.codesArray.filter((item) => {
          return item.code == item3;
        });

        if (this.canvasPreviewTemplate)
          this.canvasPreviewTemplate.canvas.dispose();
        this.canvasPreviewTemplate = {};

        setTimeout(() => {
          // ustvarimo nov fabricCanvas
          this.canvasPreviewTemplate.canvas = new fabric.Canvas(
            this.$refs.fabricEditImageCoordinates,
            {
              width: item2.imageWidth,
              height: item2.imageHeight,
              cRatio: item2.imageAspectRatio,
              selection: false,
              enableRetinaScaling: false,
              renderOnAddRemove: true,
            }
          );

          this.canvasPreviewTemplate.canvas.setBackgroundImage(
            item2.image,
            this.canvasPreviewTemplate.canvas.requestRenderAll.bind(
              this.canvasPreviewTemplate.canvas
            ),
            {
              // Needed to position backgroundImage at 0/0
              originX: "left",
              originY: "top",
              crossOrigin: "anonymous",
            }
          );

          // najprej uveljavimo dimenzije za width, da bomo potem lahko izračunali še height
          this.canvasPreviewTemplate.canvas.setDimensions(
            { width: "100%", height: "1px" },
            { cssOnly: true }
          );

          // pridobimo realni width
          let rw =
            document.getElementById("canvasEditImageCoordinates").offsetWidth /
            this.canvasPreviewTemplate.canvas.cRatio;

          // pridobimo realni height
          let rh =
            document.getElementById("canvasEditImageCoordinates").offsetHeight /
            (this.canvasPreviewTemplate.canvas.height /
              this.canvasPreviewTemplate.canvas.width);

          console.log(
            document.getElementById("canvasEditImageCoordinates").offsetHeight,
            this.canvasPreviewTemplate.canvas.height,
            this.canvasPreviewTemplate.canvas.width
          );
          console.log(rw + " X " + rh);

          if (
            this.canvasPreviewTemplate.canvas.width < rw &&
            this.canvasPreviewTemplate.canvas.height < rh
          ) {
            this.canvasPreviewTemplate.canvas.setDimensions(
              {
                width: this.canvasPreviewTemplate.canvas.width + "px",
                height: this.canvasPreviewTemplate.canvas.height + "px",
              },
              { cssOnly: true }
            );
          } else if (
            document.getElementById("canvasEditImageCoordinates")
              .offsetHeight <= rw
          ) {
            // če je potreben scroll potem nastavimo višino kot glavno stranico za prikaz
            this.canvasPreviewTemplate.canvas.setDimensions(
              {
                width: rh + "px",
                height: "100%",
              },
              { cssOnly: true }
            );
          }
          // sicer izrišemo glavno stranico kot width
          // dodamo še izračunani height
          else
            this.canvasPreviewTemplate.canvas.setDimensions(
              { width: "100%", height: rw + "px" },
              { cssOnly: true }
            );

          // dodamo kvadrat s koordinatami
          console.log(cArray[0].coordinates);
          let rectangle = null;
          if (
            Number(cArray[0].coordinates.width) <= 0 ||
            Number(cArray[0].coordinates.height <= 0)
          ) {
            rectangle = new fabric.Rect({
              width:
                this.$store.state.storeGift.getTemplateDimensions.width / 3,
              height:
                this.$store.state.storeGift.getTemplateDimensions.height / 3,
              top: item2.imageHeight / 2,
              left: item2.imageWidth / 2,
              centeredScaling: true,
              angle: 0,
              originX: "center",
              originY: "center",
              fill: "rgba(100,200,200,0.35)",
              stroke: "red",
              strokeWidth: 1,
            });
          } else
            rectangle = new fabric.Rect({
              width: Number(cArray[0].coordinates.width),
              height: Number(cArray[0].coordinates.height),
              top: Number(cArray[0].coordinates.top),
              left: Number(cArray[0].coordinates.left),
              angle: Number(cArray[0].coordinates.angle),
              centeredScaling: true,
              originX: "center",
              originY: "center",
              fill: "rgba(100,200,200,0.35)",
              stroke: "red",
              strokeWidth: 1,
            });

          rectangle.setControlsVisibility({
            tl: true,
            tr: true,
            bl: true,
            br: true,
            ml: false,
            mt: false,
            mr: false,
            mb: false,
            mtr: true,
          });

          rectangle.set({
            //centeredScaling: true,
            rotatingPointOffset: this.canvasPreviewTemplate.canvas.width / 25,
            borderColor: "rgba(255,0,0,0.5)",
            cornerSize: this.$vuetify.breakpoint.smAndUp
              ? this.canvasPreviewTemplate.canvas.width / 50
              : this.canvasPreviewTemplate.canvas.width / 12,
            cornerShape: "rect",
            cornerStrokeColor: "rgba(0,0,0,0)",
            borderScaleFactor: this.canvasPreviewTemplate.canvas.width / 200,
            transparentCorners: true,
          });

          rectangle.customiseCornerIcons({
            tl: {
              icon: this.resizeIconTL,
            },
            tr: {
              icon: this.resizeIconTR,
            },
            bl: {
              icon: this.resizeIconBL,
            },
            br: {
              icon: this.resizeIconBR,
            },
            // only is hasRotatingPoint is not set to false
            mtr: {
              icon: this.rotateIconSVG,
            },
          });

          // Render the Rect in canvas
          this.canvasPreviewTemplate.canvas.add(rectangle);
          this.canvasPreviewTemplate.canvas.requestRenderAll();
        }, 500);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    deletePrintSizeImageSet(x) {
      this.dialogDeletePrintSizeImage = true;
      this.dialogDeleteId = x;
    },
    async deletePrintSizeImage() {
      console.log("DELETE IMAGE", this.dialogDeleteId);
      this.dialogWait = true;

      let deleteImage = firebase
        .functions()
        .httpsCallable("deleteImageFromStorage");

      deleteImage([this.dialogDeleteId.item2.imageURL])
        .then((res) => {
          this.dialogWait = false;
          this.dialogDeletePrintSizeImage = false;
          console.log(res);
          if (res.data == "OK") {
            try {
              this.$store.dispatch(
                "deleteGiftPrintSizeImage",
                this.dialogDeleteId
              );
              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("msgSuccessImageDelete"),
              });
            } catch (error) {
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: error,
              });
            }
          } else {
            this.dialogWait = false;
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("msgActionError"),
            });
          }
        })
        .catch((error) => {
          this.dialogWait = false;
          console.log(error);
        });
    },
    deleteItemPrintSizeSet(ids) {
      this.dialogDeletePrintSize = true;
      this.dialogDeleteId = ids;
    },
    async deleteItemPrintSize() {
      try {
        await this.$store.dispatch("removeGiftPrintSize", this.dialogDeleteId);
        await this.$store.dispatch("getGift", {
          client: this.$store.state.storeClient.client.basicSettings.name,
          mode: "edit",
        });

        this.dialogDeletePrintSize = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessDelete"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    deleteItemTypeSet(ids) {
      this.dialogDeleteType = true;
      this.dialogDeleteId = ids;
    },
    async deleteItemType() {
      try {
        await this.$store.dispatch("removeGiftType", this.dialogDeleteId);
        await this.$store.dispatch("getGift", {
          client: this.$store.state.storeClient.client.basicSettings.name,
          mode: "edit",
        });

        this.dialogDeleteType = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessDelete"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("removeGift", this.dialogDeleteId);
        this.dialogDelete = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessDelete"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    editItem(item) {
      if (item == "add") {
        this.editedItem.price = String(this.editedItem.price);
        this.editedItem.order = String(this.editedItem.order);
        this.editedItem.minOrder = String(this.editedItem.minOrder);
        this.editedItem.maxTemplateClones = String(
          this.editedItem.maxTemplateClones
        );
        this.editedItem.overrideSizeWidth = String(
          this.editedItem.overrideSizeWidth
        );
        this.editedItem.overrideSizeHeight = String(
          this.editedItem.overrideSizeHeight
        );
      } else {
        this.editedIndex = this.$store.state.storeGift.gift.indexOf(item);
        item.image2 = item.image; // duplikat, da ne izgine slika v prikazu baze
        item.image = [];

        item.price = String(item.price);
        item.order = String(item.order);
        item.minOrder = String(item.minOrder);
        item.maxTemplateClones = String(item.maxTemplateClones);
        item.overrideSizeWidth = String(item.overrideSizeWidth);
        item.overrideSizeHeight = String(item.overrideSizeHeight);

        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      }
    },
    editType(payload) {
      this.editedIndex = this.$store.state.storeGift.gift.indexOf(payload.item);
      this.currentTypeId = payload.item.id;
      payload.type.image2 = payload.type.image; // duplikat, da ne izgine slika v prikazu baze
      payload.type.image = [];
      payload.type.inventory = String(payload.type.inventory);
      payload.type.price = String(payload.type.price);
      this.editedItemType = Object.assign({}, payload.type);
      this.dialogType = true;
    },
    editPrintSize(payload) {
      console.log(payload);
      this.editedIndex = this.$store.state.storeGift.gift.indexOf(payload.item);
      this.currentPrintSizeId = payload.item.id;
      payload.type.image2 = payload.type.image; // duplikat, da ne izgine slika v prikazu baze
      payload.type.image = [];
      this.editedItemPrintSize = Object.assign({}, payload.type);
      this.dialogPrintSize = true;
    },
    openTemplates(item) {
      // preberemo vse kode in jih damo v array, ki ga posredujemo naprej
      let codes1 = [];
      Array.from(item.printSizeArray).forEach((x) => {
        Array.from(x.codes.split("|")).forEach((y) => {
          codes1.push(y);
        });
      });
      this.$store.state.storeImageTemplate.filterSubTemplate = codes1;
      this.$router.push({
        path: "/settingsImageTemplate/" + G_MODULE_PHOTO_GIFT,
      });
    },
    async refresh() {
      await this.$store.dispatch("getGift", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: "edit",
      });
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialog = false;
      this.refresh();
    },
    closeType() {
      this.editedItemType = Object.assign({}, this.defaultItemType);
      this.editedIndex = -1;
      this.dialogType = false;
      this.refresh();
    },
    closePrintSize() {
      this.editedItemPrintSize = Object.assign({}, this.defaultItemPrintSize);
      this.editedIndex = -1;
      this.dialogPrintSize = false;
      this.refresh();
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        this.dialogWait = true;
        if (this.editedIndex > -1) {
          try {
            if (Array.isArray(this.editedItem.image))
              delete this.editedItem.image;
            await this.$store.dispatch("editGift", this.editedItem);
            await this.$store.dispatch("getGift", {
              client: this.$store.state.storeClient.client.basicSettings.name,
              mode: "edit",
            });

            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            if (Array.isArray(this.editedItem.image))
              delete this.editedItem.image;
            await this.$store.dispatch("addGift", this.editedItem);

            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
    async saveType() {
      if (this.$refs.formType.validate()) {
        this.dialogType = false;
        this.dialogWait = true;

        try {
          if (Array.isArray(this.editedItemType.image))
            delete this.editedItemType.image;

          Object.assign(this.editedItemType, {
            recordId: this.currentTypeId,
            client: this.$store.state.storeClient.client.basicSettings.name,
          });

          if (this.editedIndex > -1) {
            await this.$store.dispatch("editGiftType", this.editedItemType);
          } else await this.$store.dispatch("addGiftType", this.editedItemType);

          await this.$store.dispatch("getGift", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            mode: "edit",
          });

          this.dialogWait = false;

          this.$store.commit({
            type: "showSnackbar",
            color: "success",
            message: this.$t("msgSuccessAdd"),
          });
        } catch (error) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: error,
          });
        }

        this.closeType();
      }
    },
    async savePrintSize() {
      if (this.$refs.formPrintSize.validate()) {
        this.dialogPrintSize = false;
        this.dialogWait = true;

        try {
          if (Array.isArray(this.editedItemPrintSize.image)) {
            delete this.editedItemPrintSize.image;
          } else {
            // če je slika izbrana, preberemo dimenzije
            readImageDimensions(this.editedItemPrintSize.image).then((x) => {
              this.editedItemPrintSize.imageWidth = x.width;
              this.editedItemPrintSize.imageHeight = x.height;
              this.editedItemPrintSize.imageAspectRatio = x.aspectRatio;
            });
          }

          Object.assign(this.editedItemPrintSize, {
            recordId: this.currentPrintSizeId,
            client: this.$store.state.storeClient.client.basicSettings.name,
          });

          if (this.editedIndex > -1) {
            await this.$store.dispatch(
              "editGiftPrintSize",
              this.editedItemPrintSize
            );
          } else
            await this.$store.dispatch(
              "addGiftPrintSize",
              this.editedItemPrintSize
            );

          await this.$store.dispatch("getGift", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            mode: "edit",
          });

          this.dialogWait = false;

          this.$store.commit({
            type: "showSnackbar",
            color: "success",
            message: this.$t("msgSuccessAdd"),
          });
        } catch (error) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: error,
          });
        }
        this.closePrintSize();
      }
    },
  },
  created() {
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;

    this.$store.dispatch("getGiftCategory", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      mode: "edit",
    });
    this.$store.dispatch("getGift", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      mode: "edit",
    });
  },
};
</script>
